import { useRoute, useRouter } from 'vue-router';
import { useUiStore } from '@common/stores';

export const useRedirectionTools = () => {
  const route = useRoute();
  const router = useRouter();
  const uiStore = useUiStore();

  return {
    getRealmEndpoint(endpoint: string) {
      return endpoint
        .replace(':realm', uiStore.realm.id)
        .replace('{0}', uiStore.realm.id);
    },

    async redirectToAsync(endpoint: string) {
      const resetCredentialsRoute = this.getRealmEndpoint(endpoint);

      const redirectUri = encodeURIComponent(route.query.redirect_uri?.toString() ?? '');

      await router.push(`${resetCredentialsRoute}?redirect_uri=${redirectUri}`);
    },
  };
};